import { Grid } from '@mui/material';
import { Form, Formik, FormikProps } from 'formik';
import React from 'react';
import { useHistory } from 'react-router-dom';
import Banner from '@cpg-its/ads.containers.banner';
import { FormField } from '../../../../../global/components/form-element/form-field';
import { FormWrapper } from '../../../../../global/components/form-wrapper';
import { DividerSection } from '../../../../../global/components/layout/divider-section';
import { LabelSettingProps } from '../../../../../global/models/epi-model';
import { EmploymentProps } from '../../../models/arc-epi-props';
import { AddUnpaidLeaveFormModel, AddUnpaidLeaveValidationSchema } from './add-unpaid-leave-form-models';
import { ContentSpacer } from '../../../../../global/components/layout/generic-content-spacer';
import { useApiResponseError } from '../../../../../global/hooks/useApiError';
import { FormBaseModel } from '../../../../../global/models/page-model';
import { PageHeader } from '../../../../../global/components/layout/page-header';
import { getCurrentFormattedDateNY } from '../../../../../global/helpers/form-data-helper';

interface AddUnpaidLeaveFormProps extends FormBaseModel {
    onSubmitHandler: (values: AddUnpaidLeaveFormModel) => any;
    employmentProps: EmploymentProps;
    labelSettings: LabelSettingProps;
    previousRoute: string;
    employmentId: number;
}

export function AddUnpaidLeaveForm(props: AddUnpaidLeaveFormProps) {
    const {
        onSubmitHandler,
        employmentProps,
        labelSettings,
        previousRoute,
        employmentId } = props;

    const history = useHistory();
    const apiErrors = useApiResponseError();

    const initialValues: AddUnpaidLeaveFormModel = {
        employment_id: employmentId,
        start_date: getCurrentFormattedDateNY(),
        acknowledge: false,
    };


    return (
        <Formik
            initialValues={initialValues}
            onSubmit={(values) => { onSubmitHandler(values); }}
            validationSchema={AddUnpaidLeaveValidationSchema(employmentProps, labelSettings)}
            enableReinitialize
            initialErrors={apiErrors}
        >
            {(formProps: FormikProps<AddUnpaidLeaveFormModel>) => (
                <Form>
                    <Grid>
                        <FormWrapper
                            formikProps={formProps}
                            submitText={labelSettings.submitText}
                            cancelText={labelSettings.cancelText}
                            onCancel={() => history.push(previousRoute)}
                            submitDisabled={!formProps.values.acknowledge}
                        >
                            <PageHeader
                                headerText={props.formHeader}
                                description={props.formDescription}
                            />
                            <DividerSection removeDivider>
                                <ContentSpacer>
                                    <FormField
                                        name='start_date'
                                        label={employmentProps.startDateLabel}
                                        component='datePicker'
                                        touched={formProps.touched}
                                        errors={formProps.errors}
                                        required
                                        autoWidth
                                    />

                                </ContentSpacer>
                                <ContentSpacer>
                                    <Banner
                                        banner={{
                                            type: 'warning',
                                            description: <div dangerouslySetInnerHTML={{ __html: employmentProps.beAwareMessage }} />,
                                            label: <p className='input-label'>{employmentProps.beAwareMessageTitle}</p>,

                                        }}
                                    />
                                </ContentSpacer>

                                <FormField
                                    name='acknowledge'
                                    label={employmentProps.acknowledgeTexts}
                                    component='checkBox'
                                    touched={formProps.touched}
                                    errors={formProps.errors}
                                    value={formProps?.values?.acknowledge ?? false}
                                    checked={formProps?.values?.acknowledge ?? false}
                                />
                            </DividerSection>
                        </FormWrapper>
                    </Grid>
                </Form>

            )}
        </Formik >
    );
}